import React, { useState,useEffect } from "react";
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import Swal from "sweetalert2";
import './Pricing.css';
import $ from 'jquery';

const Pricing = () => {
     useEffect(() => {
    // Preloader
      $(window).on('load', function () {
          $('.preloader').delay(1000).fadeOut(1000);
        });
        setTimeout(() => {
          $('.preloader').fadeOut(1000);
        }, 2000);
  });
  // All state and handlers moved inside the component
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    description: '',
    plan: ''
  });
  
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);

  const handlePlanClick = (planName) => {
    setFormData(prev => ({
      ...prev,
      username: '',
      email: '',
      description: '',
      plan: planName
    }));
    // setShowModal(true);
  };

  const handleCloseModal = () => {
    // setShowModal(false);
    setFormData(prev => ({ 
      ...prev, 
      plan: '',
      username: '',
      email: '',
      description: ''
    }));
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();
    setIsContactSubmitting(true);

    try {
      const subject = formData.plan 
        ? `Someone wants to buy ${formData.plan} plan of RefMex` 
        : 'Someone contacted you from Refmex.com';

      const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          subject
        }),
      });

      if (response.ok) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Message sent successfully!',
          showConfirmButton: false,
          timer: 2000
        });
        setFormData({
          username: '',
          email: '',
          description: '',
          plan: ''
        });
        // setShowModal(false);
      } else {
        const errorResponse = await response.text();
        let errorMessage;
        try {
          const jsonResponse = JSON.parse(errorResponse);
          errorMessage = jsonResponse.message;
        } catch (e) {
          errorMessage = 'An unknown error occurred';
        }
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `Failed to send message: ${errorMessage}`,
          showConfirmButton: true
        });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred. Please try again later.',
        showConfirmButton: true
      });
    } finally {
      setIsContactSubmitting(false);
    }
  };

  return (
    <>
        <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>      

        <section id="about-us-page" className="about-us-section">
          <div className="container zindex">
            <div className="pricing-header text-center">
              <h3>Simple, Honest Pricing. <span className="highlight">No Hidden Fees.</span></h3>
              <p className="subheader">Start with a free trial. Upgrade only when you see the value.</p>
            </div>

          <div className="row price-pa">
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Free</h3>
                <h4><sub>$</sub>0<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> 1 Demo Account without Integration</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Limited Time</p>
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i>Demo, 1 Location</p> */}
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Demo </p> */}
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Free')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
              </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Starter</h3>
                <h4><sub>$</sub>19<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Single location</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Dashboard</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> 1 Refmex form</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Prebuilt templates</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Email support</p>
                <div className="price-btn text-center">
                  <a href="#" onClick={() => handlePlanClick('Starter')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mob-mar-bottom">
              <div className="price-table gold-bg">
                <h3 className="gold">Pro</h3>
                <h4><sub>$</sub>49<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Multi location</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Up to 5 locations</p>
                 <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Custom forms</p>
                  <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> API access</p>
                   <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Priority support</p>
                <div className="price-btn gold-bg2 text-center">
                  <a href="#" onClick={() => handlePlanClick('Pro')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table">
                <h3>Enterprise</h3>
                <h4><sub>$</sub>499<sub>/Year</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Chains & large service brands</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Unlimited locations</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Custom API configs</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> SLA</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Account Manage</p>
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Enterprise')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
              </div>
              </div>
            </div>
          </div>

            {/* All Plans Features */}
            <div className="all-plans-features">
              <h4 className="section-title">All plans include:</h4>
              <div className="features-grid">
                <div className="feature-item">
                 <i className="fa fa-check-circle-o check-style" aria-hidden="true"></i>
                  <span>Unlimited Refmex submissions</span>
                </div>
                <div className="feature-item">
                 <i className="fa fa-check-circle-o check-style" aria-hidden="true"></i>
                  <span>Mobile/tablet-friendly UI</span>
                </div>
                <div className="feature-item">
                 <i className="fa fa-check-circle-o check-style" aria-hidden="true"></i>
                  <span>Export to CSV/Excel</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Modal */}
  <div className={`modal fade ${showModal ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" 
    style={{ display: showModal ? 'block' : 'none', backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">
          {formData.plan ? `Interested in ${formData.plan} Plan` : 'Contact Us'}
        </h5>
        {/* <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> */}
      </div>
      <form onSubmit={handleContactSubmit}>
        <div className="modal-body">
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-user-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control box-bg"
              placeholder="Your Name"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>
          
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-envelope-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="email"
              className="form-control box-bg"
              placeholder="Your Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>
          
          <div className="form-group">
            <textarea
              className="form-control box-bg"
              placeholder="Your Message"
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
            ></textarea>
          </div>
          
          {formData.plan && (
            <input type="hidden" name="plan" value={formData.plan} />
          )}
        </div>
        <div className="modal-footer">
          {/* <button type="button" className="dropboxx" onClick={handleCloseModal}>
            Close
          </button> */}
          <button
            type="submit"
            className="dropboxx2"
            disabled={isContactSubmitting}
          >
            {isContactSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>



        <Footer />
      </div>
    </>
  );
};

export default Pricing;